import { OfferLine, type OfferNote } from "./OfferLine";
import {
  addsFor,
  offerKey,
  reasonText,
  type RecommendedIssuer,
  type RecommendedOffer,
} from "../lib/worthAdding";

/**
 * Next run, for one issuer that adds for you: exactly what its next run
 * presses and on which card, from the server's plan rule (`next_run`). Don't
 * add is Not interested.
 */
export function NextRunList({ issuer, offers, today, soonDays, isFlagged, onDontAdd }: {
  issuer: RecommendedIssuer;
  offers: RecommendedOffer[];
  today: string;
  soonDays: number;
  isFlagged: (offer: RecommendedOffer) => boolean;
  onDontAdd: (offer: RecommendedOffer) => void;
}) {
  const adds = issuer.next_run ?? [];
  const oneCard = adds.some((a) => a.reason);
  return (
    <div className="overflow-hidden rounded-xl border border-neutral-800 bg-neutral-900">
      <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1 border-b border-neutral-800 px-3 py-2.5">
        <span className="text-[14px] font-semibold">{issuer.issuer}</span>
        <span className="rounded-full bg-green-500/10 px-2 text-[11px] font-semibold text-green-400">Auto-add on</span>
        <span className="text-[11.5px] text-neutral-500">
          {oneCard ? "One card per offer" : "Every card that lists it"}
        </span>
        <span className="ml-auto text-xs text-neutral-400">{offers.length} on the next run</span>
      </div>
      <ul className="divide-y divide-neutral-800">
        {offers.map((offer) => {
          const mine = addsFor(offer, adds);
          const notes: OfferNote[] = [];
          const why = mine.length === 1 ? reasonText(mine[0].reason, mine[0].card_name) : null;
          if (offer.unconfirmed && mine[0]?.reason !== "retry") {
            notes.push({ text: "not confirmed last run, tried again next run", tone: "text-amber-400" });
          }
          if (why) notes.push({ text: why, tone: "text-neutral-500" });
          if (isFlagged(offer) && !offer.worth) notes.push({ text: "flagged by you", tone: "text-neutral-500" });
          return (
            <OfferLine
              key={offerKey(offer)}
              offer={offer}
              cards={issuer.cards}
              today={today}
              soonDays={soonDays}
              goesTo={new Set(mine.map((a) => a.card_id))}
              notes={notes}
              action={
                <button type="button" onClick={() => { onDontAdd(offer); }} className="btn btn-ghost btn-sm">
                  Don't add
                </button>
              }
            />
          );
        })}
      </ul>
    </div>
  );
}
